/*
 * We should definitely use ref when we are working with DOM nodes in react
 * but for current implementation we use element id
 * */
export const scrollToElementById = (
  elementId: string,
  options?: ScrollIntoViewOptions,
) => {
  const node = document.getElementById(elementId);

  if (node) {
    // prefer scrolling in the middle. However, if the target is taller than
    // the browser viewport, it scrolls in the middle of target which is
    // confusing, in this case scroll in the beginning of the target
    const { height } = node.getBoundingClientRect();
    const scrollLogicalPosition: ScrollLogicalPosition =
      height > window.innerWidth ? 'start' : 'center';

    node.scrollIntoView({
      behavior: 'smooth',
      block: scrollLogicalPosition,
      ...options,
    });
  }
};
